import React,{Component,useEffect,useState} from 'react'
import {auth,data} from './firebase';
import './css/Products.css'
import PhoneIcon from '@material-ui/icons/Phone';
import WatchLaterIcon from '@material-ui/icons/WatchLater';
import LocationOnIcon from '@material-ui/icons/LocationOn';
function Products() {
    var ara=[];
    const a =window.location.href.split("/");
    const [usepro,setdpro]=useState([]);
    const [userdata,setUserData]=useState([]);

    useEffect(()=>{
        
        fetchBlogs();
    },[])
    const fetchBlogs=async()=>{
        if(a[4]){
            const response=data.collection('Products').doc(a[4]);
            const dat=await response.get();
            setdpro(dat.data())
        }else{
            window.location.replace("/")
        }
        
    }
    data.collection("Users").doc(usepro.UID).onSnapshot(y=>(
        setUserData(y.data())
    ))
    function Number() {
        var b=document.getElementById("button")
        var icon=document.getElementById("icon")
        var text=document.getElementById("text")
        b.style.backgroundColor="white"
        b.style.border=".1rem solid #2e6bff"
        b.style.color="#2e6bff"
        b.style.cursor="default"
        icon.style.display="none"
        text.innerHTML=userdata.Téléphone
    }

    return (
        <div className="allpage">
            <div className="Productdet">
                <img src={usepro.img}></img>
                <div className="titleprix">
                    <p className="prix">{usepro.prix}</p>
                    <p className="title">{usepro.title}</p>
                    <div className="dateinfo">
                        <p><LocationOnIcon className="ico"/>{usepro.city}</p>
                        <p><WatchLaterIcon className="ico"/>{usepro.DayNum} {usepro.Day}</p>
                    </div>
                </div>
                <div className="line"></div>
                <div className="description">
                    <p>Description</p>
                    <p>{usepro.Texte}</p>
                </div>
            </div>

            <div className="Userdet">
                <p>{userdata?userdata.Prénom:""}</p>
                <button onClick={Number} id="button">
                    <PhoneIcon className="icon" id="icon"/>
                    <p id="text">Afficher le numéro</p>
                </button>
            </div>
        </div>
    )
}

export default Products
